import React from 'react';
import PropTypes from 'prop-types';

const ScreenSelector = React.createClass({
    propTypes: {
        screens: PropTypes.arrayOf(PropTypes.object),
        screenZoneData: PropTypes.object,
        isAvailable: PropTypes.bool,
        selectedScreenId: PropTypes.string,
        onScreenSelected: PropTypes.func
    },
    onChange: function(e) {
        let val = e.currentTarget.value;
        if (val) {
            this.props.onScreenSelected(val);
        }
    },
    render: function() {
        return (this.props.screens.length && this.props.isAvailable) ? (
            <div className="syos-key syos-key--optional">
                <ul className="syos-key__list">
                    {this.props.screens.map((screen, idx) => {
                        let zoneData = this.props.screenZoneData[screen.screen_no];
                        let disabled = (zoneData === undefined || zoneData.avail < 1);

                        return (
                            <li className="syos-key__list__item" key={screen.screen_no}>
                                <input type="radio"
                                    className="syos-key__option-input"
                                    onChange={this.onChange}
                                    name="radio-screen" id={`radio-screen-${idx}`}
                                    value={screen.screen_no}
                                    checked={this.props.selectedScreenId === screen.screen_no}
                                    disabled={disabled}
                                />
                                <label className="syos-key__option-label"
                                    htmlFor={`radio-screen-${idx}`}>
                                    {screen.screen_desc}
                                </label>
                            </li>
                        )
                    })}
                </ul>
            </div>
        ) : null;
    }
});

export default ScreenSelector;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/ScreenSelector.js